import {isDevMode, OnInit} from '@angular/core'
import {PaginationService} from '../../core/pagination/paginator.service';
import {IContent, IPagin} from '../../core/pagination/IPaginator-model';
import * as _ from 'lodash';
import {MessageService} from "primeng/components/common/messageservice";

export class PaginationComponent implements OnInit {

  data: IPagin = null;
  data2Find: IPagin = null;
  loading: boolean;

  totalPages: number[];
  content: any[];
  last: boolean = true;
  first: boolean = false;
  active: number;
  totalPagination: number[] = [5, 10, 15, 20];
  ipg: number = 0;
  totalSize: number;

  constructor(private _messageService: MessageService, private service: PaginationService) {
  }

  ngOnInit(): void {
    this.getPaginationData();
  }

  getPaginationData() {

    if (isDevMode()) {
      console.log(' [ PaginatorComponent] :: [ngOnInit] :::::');
      console.log(this.data);
    }

    this.loading = true;
    this.service.getDataToPaginator(this.data)
      .finally(() => this.loading = false)
      .subscribe((res: IContent) => {
          if (res) {
            this.totalPages = Array.from(new Array(res.totalPages), (val, index) => index);
            this.setDataFromPromise(res, false)
          }
        },
        err => {
          console.error('ERROR', err);
          this._messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err
          });
        })
  }

  getPage(page: number): void {

    if (isDevMode()) {
      console.log(' [ PaginatorComponent] :: [getPage] :::::', page);
      console.log(this.data);
    }

    let newPage = {endPoint: this.data.endPoint, path: this.data.path, size: this.data.size, page: page};
    this.loading = true;

    this.service.getDataToPaginator(newPage)
      .finally(() => this.loading = false)
      .subscribe((res: IContent) => {
          this.setDataFromPromise(res, false)
        },
        err => {
          console.error('ERROR', err);
          this._messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err
          });
        })
  }

  getPagePaymentsByStatusage(page: number, status: string): void {
    if (isDevMode()) {
      console.log(' [ PaginatorComponent] :: [getPage] :::::', page);
      console.log(this.data2Find);
    }
    let newPage = {path: this.data.path, size: this.data.size, page: page, status: status}
    console.log(newPage);
    this.loading = true;
    this.service.getPaymentsByStatus(newPage)
      .finally(() => this.loading = false)
      .subscribe((res: IContent) => {
          console.log(res);
          this.setDataFromPromise(res, true)
        },
        err => {
          console.error('ERROR', err);
          this._messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err
          });
        })
  }

  setDataFromPromise(data: IContent, isByStatus: boolean) {

    if (isDevMode()) {
      console.log(' [ PaginatorComponent] :: [setDataFromPromise] :::::');
    }

    if (data) {

      this.active = data.number;
      if (!isByStatus && this.data.path == "payments") {
        _.forEach(data.content, item => {
          item.wagerReferenceIdKey = item.wagerReferenceId + '_' + item.producto;
        });
      }

      this.content = this.processContent(data.content);
      this.last = data.last;
      this.first = data.first;
      this.totalSize = data.totalElements;

    }

    if (isDevMode()) {
      console.log(`${data.content.length} === ${this.totalSize}`);
    }

  }

  processContent(content: any[]) {
    return content;
  }

  changePagination(pg: number) {
    if (isDevMode()) {
      console.log(' [ PaginatorComponent] :: [changePagination] :::::');
      console.log(pg)
    }
    this.ipg = pg;
    this.data.size = pg;
    this.ngOnInit()
  }

  showAll() {
    if (isDevMode()) {
      console.log(' [ PaginatorComponent] :: [showAll] :::::');
    }

    this.ipg = 0;
    this.data.size = this.totalSize;
    this.ngOnInit()
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/pagination/pagination.component.ts